export const NotFoundPageTranslationsUk = {
  'Page not found': 'Сторінка не знайдена',
  'Problem explanation':
    'Вибачте, ми не змогли знайти сторінку, яку ви шукаєте. Спробуйте повторити пошук.',
  Homepage: 'На головну',
};
